import classNames from 'classnames';
import PodcastArticle from '../podcast-article/podcast-article.component';
import styles from './podcast-block.module.scss';
import useIntersection from '../../hooks/use-intersection';
import { useEffect, useRef } from 'react';

import { PodcastBlockInterface } from './podcast-block.interface';

const PodcastBlock: React.FunctionComponent<PodcastBlockInterface> = ({
  id,
  className,
  leftPhoto,
  rightPhoto,
  articleData,
  onReadArticleClick,
  onPodcastOpenChange,
}) => {
  const elementRef = useRef() as React.MutableRefObject<HTMLElement>;
  const photoRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const isPhotoVisible = useIntersection({
    ref: photoRef,
    options: {
      rootMargin: '-20% 0px',
    },
  });

  const openedChanged = (opened: boolean) => {
    if (onPodcastOpenChange) {
      onPodcastOpenChange(opened);
    }
  };

  useEffect(() => {
    const { current } = elementRef;
    const podcasts = current.querySelector<HTMLElement>(`article[class^='podcast-links_component'] > div > div`);
    // const photos = Array.from(current.querySelectorAll<HTMLElement>('.' + classNames(styles.photo)));

    const resize = () => {
      const { offsetHeight: podcastHeight } = podcasts!;

      current.style.setProperty('--p-height', podcastHeight + 'px');
    };

    new ResizeObserver(resize).observe(podcasts!);
    new ResizeObserver(resize).observe(current!);

    // photos.forEach(p => new ResizeObserver(resize).observe(p));

    resize();
    queueMicrotask(() => resize());
  }, []);

  return (
    <article
      ref={elementRef}
      id={id}
      className={classNames(
        styles.component,
        className,
        {
          [styles.isPhotoVisible]: isPhotoVisible,
        },
      )}
    >
      <PodcastArticle
        id={id}
        className={classNames(styles.article)}
        {...articleData}
        onReadArticleClick={onReadArticleClick}
        onOpenedChange={openedChanged}
      >
        {(isOpened) => {
          return (
            <>
              <div
                ref={photoRef}
                className={classNames(styles.photo, styles.photoLeft, { [styles['p-opened']]: isOpened })}
              ><img src={leftPhoto} alt="" /></div>
              <div
                className={classNames(styles.photo, styles.photoRight, { [styles['p-opened']]: isOpened })}
              ><img src={rightPhoto} alt="" /></div>
            </>
          );
        }}
      </PodcastArticle>
    </article>
  );
};

export default PodcastBlock;
